<template>
  <validation-provider
    :rules="rules"
    :name="name"
    :vid="vid"
    ref="validator"
    v-slot="{ valid, errors }"
  >
    <div
      class="control"
      :class="{
        'has-icons': iconLeft || iconRight,
        'has-icons-left': iconLeft,
        'has-icons-right': iconRight
      }"
    >
      <input
        :type="type"
        ref="input"
        class="input"
        :class="{
          'is-danger': errors.length > 0,
          'is-success': successMark && errors.length === 0 && valid
        }"
        :placeholder="placeholder"
        v-model="currentValue"
      />
      <icon :name="iconLeft" class="is-left" />
      <icon :name="iconRight" class="is-right" />
      <p class="help is-danger">{{ errors[0] }}</p>
      <p
        class="help is-success"
        v-if="
          successMark &&
            errors.length === 0 &&
            valid &&
            typeof successMark === 'string'
        "
      >
        {{ successMark }}
      </p>
    </div>
  </validation-provider>
</template>

<script>
import { Icon } from "%helpers";

export default {
  name: "control-input",

  components: {
    Icon
  },

  props: {
    type: {
      type: String,
      default: "text"
    },

    vid: String,
    name: String,
    rules: [Object, String],

    iconLeft: String,
    iconRight: String,

    value: undefined,
    placeholder: String,
    successMark: [Boolean, String]
  },

  data() {
    return {
      currentValue: ""
    };
  },

  mounted() {
    this.currentValue = this.value;
  },

  methods: {
    setErrors(errors) {
      this.$refs.validator.setErrors(errors);
    },

    focus() {
      this.$refs.input.focus();
    },

    blur() {
      this.$refs.input.blur();
    }
  },

  watch: {
    value(val) {
      this.currentValue = val;
    },

    currentValue(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style></style>
